// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"cardWrapper__1c1Gi"};